import {Category} from '@digital-supply-chain/module'

export const ShareaCategorys = [
    Category.EnterpriseDir,
    Category.LectoFavoriteDir
];
